import { buttonVariants } from "@/components/ui/button";
import { settingsLinks } from "@/constants";
import { useShopifySuccessMutation } from "@/hooks/shopify";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/$org/shopify/success")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const mutate = useShopifySuccessMutation();
  const navigate = useNavigate();
  const { org } = Route.useParams();

  useEffect(() => {
    const path = `/${org}${settingsLinks.get("billing")}`;
    mutate.mutate();

    navigate({ to: path });
  }, []);
  return (
    <div>
      {t("common.redirectingSoon")}{" "}
      <Link
        className={buttonVariants({ variant: "outline" })}
        to={`/$org/settings/billing`}
        params={{ org }}
      >
        {t("common.clickIfNotRedirecting")}
      </Link>
    </div>
  );
}
